import { useSessionStore } from '@/stores/SessionStore.ts';
import { useAuthStore } from '@/stores/AuthStore.ts';
import { useClientStore } from '@/stores/ClientStore.ts';
import { useSourceStore } from '@/stores/SourceStore.ts';
import { usePromptStore } from '@/stores/PromptStore.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { useUserInfoStore } from '@/stores/UserInfoStore.ts';
import { useWebSocketStore } from '@/stores/WebSocketStore.ts';
import { router, ROUTES } from '@/router.ts';
import { setLoggingLevelAction } from '@/actions/app/SetLoggingLevelAction.ts';

export const fullResetAction = async () => {
    const authStore = useAuthStore();
    authStore.$reset();

    const clientStore = useClientStore();
    clientStore.$reset();

    const hostStore = useSourceStore();
    hostStore.$reset();

    const promptStore = usePromptStore();
    promptStore.$reset();

    const sessionStore = useSessionStore();
    sessionStore.$reset();

    const settingsStore = useSettingsStore();
    settingsStore.$reset();

    const userInfoStore = useUserInfoStore();
    userInfoStore.$reset();

    const webSocketStore = useWebSocketStore();
    webSocketStore.$reset();

    if (import.meta.env.DEV) {
        setLoggingLevelAction('debug');
    }

    void router.push(ROUTES.authLogin);
};
